export var DOCUMENT_IMAGE_PLACEHOLDER = undefined;
export var PRODUCT_IMAGE_PLACEHOLDER = {
    // FIXME: this is not final image, update once we have a proper way to export it:
    // https://jira.wixpress.com/browse/SER-1596
    name: 'b49ee3_18ac770179aa4404ade6c21caae1fe65~mv2.jpg',
};
//# sourceMappingURL=DocumentParser.constants.js.map